import moment from 'moment';
import React, { Component } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import ja from 'date-fns/locale/ja';
import { connect } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import './ExternalDataHistorySearchComponent.css';
import {
  Box, Typography, TextField, Grid, Button,
} from '@material-ui/core';
import { Search, Refresh } from '@material-ui/icons';
import validator, { VALIDATOR_CONST } from '../../../common/validator';
import { ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';
import { setSystemLodingFLg, setErrorMessage } from '../../actions/CommonAction';
import {
  setInitExternalDataSendHistoryState,
  setExProcessNoFrom,
  setExProcessNoTo,
  setCreateDateFrom,
  setCreateDateTo,
  setLinkageProcessNo,
  setExNowPage,
  setExternalDataSendHistoryList,
  setInitExSearchCondition,
  searchExternalDataSendHistory,
  setErrExProcessNoFromMsg,
  setErrExProcessNoToMsg,
  setErrCreateDateFromMsg,
  setErrCreateDateToMsg,
  setErrLinkageProcessNoMsg,
  setErrExProcessNoFromFlg,
  setErrExProcessNoToFlg,
  setErrCreateDateFromFlg,
  setErrCreateDateToFlg,
  setErrLinkageProcessNoFlg,
  setExLimitMessage,
  startImportPolling,
  stopImportPolling,
  getImportStatus,
} from '../../actions/ExternalDataHistoryAction';
import {
  INPUT,
  DATE_TIME_FORMAT,
} from '../../../common/const';

class ExternalDataSendHistorySearchComponent extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  /**
  * 処理番号FROM
  */
onBlurExProcessNoFrom = () => {
  const {
    exProcessNoFrom,
    exProcessNoTo,
    setErrExProcessNoFromMsgAct,
    setErrExProcessNoFromFlgAct,
    setErrExProcessNoToFlgAct,
    setErrExProcessNoToMsgAct,
  } = this.props;
  const errMsg = [];
  if (exProcessNoFrom && exProcessNoFrom.length > 0) {
    // 文字種チェック(半角数字)
    validator.checkChar(exProcessNoFrom, VALIDATOR_CONST.PATERN_NUM, errMsg);
    // 桁数チェック
    validator.checkLength(exProcessNoFrom, 10, errMsg);
    if (errMsg.length !== 0) {
      setErrExProcessNoFromFlgAct(true);
      setErrExProcessNoFromMsgAct(getMessage(ERROR.E08009, errMsg.join(',')));
      return;
    }
    // 入力値チェック
    if (exProcessNoTo && exProcessNoFrom > exProcessNoTo) {
      setErrExProcessNoFromFlgAct(true);
      setErrExProcessNoToFlgAct(true);
      setErrExProcessNoFromMsgAct(getMessage('FROMに、TOを超える値が入力されています。'));
      return;
    }
    if (exProcessNoTo && exProcessNoTo.length === 10 && exProcessNoFrom <= exProcessNoTo) {
      setErrExProcessNoToFlgAct(false);
      setErrExProcessNoToMsgAct();
    }
  }
  setErrExProcessNoFromFlgAct(false);
  setErrExProcessNoFromMsgAct();
}

/**
  * 処理番号TO
  */
onBlurExProcessNoTo = () => {
  const {
    exProcessNoFrom,
    exProcessNoTo,
    setErrExProcessNoFromMsgAct,
    setErrExProcessNoFromFlgAct,
    setErrExProcessNoToMsgAct,
    setErrExProcessNoToFlgAct,
  } = this.props;
  const errMsg = [];
  if (exProcessNoTo && exProcessNoTo.length > 0) {
    // 文字種チェック(半角数字)
    validator.checkChar(exProcessNoTo, VALIDATOR_CONST.PATERN_NUM, errMsg);
    // 桁数チェック
    validator.checkLength(exProcessNoTo, 10, errMsg);
    if (errMsg.length !== 0) {
      setErrExProcessNoToFlgAct(true);
      setErrExProcessNoToMsgAct(getMessage(ERROR.E08009, errMsg.join(',')));
      return;
    }
    // 入力値チェック
    if (exProcessNoFrom && exProcessNoFrom > exProcessNoTo) {
      setErrExProcessNoFromFlgAct(true);
      setErrExProcessNoToFlgAct(true);
      setErrExProcessNoFromMsgAct(getMessage('FROMに、TOを超える値が入力されています。'));
      return;
    }
    if (exProcessNoFrom && exProcessNoFrom.length === 11 && exProcessNoFrom <= exProcessNoTo) {
      setErrExProcessNoFromFlgAct(false);
      setErrExProcessNoFromMsgAct();
    }
  }
  setErrExProcessNoToFlgAct(false);
  setErrExProcessNoToMsgAct();
}

  /**
  * 作成日FROM
  */
  onBlurExCreateDateFrom = () => {
    const {
      createDateFrom,
      createDateTo,
      setErrCreateDateFromFlgAct,
      setErrCreateDateFromMsgAct,
      setErrCreateDateToFlgAct,
      setErrCreateDateToMsgAct,
    } = this.props;

    const range = moment().subtract(3, 'M').format(DATE_TIME_FORMAT.DATE);
    const errMsg = [];

    // 作成日FROM_入力チェック
    if (createDateFrom) {
      const dateFromYYYYMMDD = moment(createDateFrom).format(DATE_TIME_FORMAT.DATE);
      if (createDateTo) {
        const dateToYYYYMMDD = moment(createDateTo).format(DATE_TIME_FORMAT.DATE);
        if (dateFromYYYYMMDD > dateToYYYYMMDD) {
          setErrCreateDateFromFlgAct(true);
          setErrCreateDateFromMsgAct(
            getMessage(ERROR.E08007, INPUT.EXTERNALDATA.CREATEDATE),
          );
          return;
        }
        if (dateToYYYYMMDD > range) {
          setErrCreateDateToFlgAct(false);
          setErrCreateDateToMsgAct();
        }
      }

      if (dateFromYYYYMMDD < range) {
        errMsg.push('3カ月以内の範囲');
        setErrCreateDateFromFlgAct(true);
        setErrCreateDateFromMsgAct(getMessage('3か月以内の範囲で入力してください。'));
        return;
      }
    }
    setErrCreateDateFromFlgAct(false);
    setErrCreateDateFromMsgAct();
  }

  /**
  * 作成日TO
  */
  onBlurExCreateDateTo = () => {
    const {
      createDateFrom,
      createDateTo,
      setErrCreateDateToFlgAct,
      setErrCreateDateToMsgAct,
      setErrCreateDateFromFlgAct,
      setErrCreateDateFromMsgAct,
    } = this.props;
    const range = moment().subtract(3, 'M').format(DATE_TIME_FORMAT.DATE);
    const errMsg = [];
    // 作成日TO_入力チェック
    if (createDateTo) {
      const dateToYYYYMMDD = moment(createDateTo).format(DATE_TIME_FORMAT.DATE);
      if (createDateFrom) {
        const dateFromYYYYMMDD = moment(createDateFrom).format(DATE_TIME_FORMAT.DATE);
        if (dateFromYYYYMMDD > dateToYYYYMMDD) {
          setErrCreateDateToFlgAct(true);
          setErrCreateDateToMsgAct(getMessage('TOに、FROMを下回る値が入力されています。'));
          return;
        }
        if (dateFromYYYYMMDD > range) {
          setErrCreateDateFromFlgAct(false);
          setErrCreateDateFromMsgAct();
        }
      }

      if (dateToYYYYMMDD < range) {
        errMsg.push('3カ月以内の範囲');
        setErrCreateDateToFlgAct(true);
        setErrCreateDateToMsgAct(getMessage('3か月以内の範囲で入力してください。'));
        return;
      }
    }
    setErrCreateDateToFlgAct(false);
    setErrCreateDateToMsgAct();
  }

  /**
  *連携先：処理番号、最大桁数のチェック
  */
  onBlurLinkageProcessNo = () => {
    const {
      linkageProcessNo,
      setErrLinkageProcessNoFlgAct,
      setErrLinkageProcessNoMsgAct,
    } = this.props;
    const errMsg = [];

    // 連携先：処理番号_入力チェック
    if (linkageProcessNo && linkageProcessNo.length > 0) {
      // 最大桁数チェック()
      validator.checkMaxLength(linkageProcessNo, 50, errMsg);

      if (errMsg.length !== 0) {
        setErrLinkageProcessNoFlgAct(true);
        setErrLinkageProcessNoMsgAct(getMessage(ERROR.E08009, errMsg.join(',')));
        return;
      }
    }
    setErrLinkageProcessNoFlgAct(false);
    setErrLinkageProcessNoMsgAct();
  }

  /**
   * 検索ボタン押下時の処理
   */
  onClickSearchButton = async () => {
    const {
      exProcessNoFrom,
      exProcessNoTo,
      createDateFrom,
      createDateTo,
      linkageProcessNo,
      setSystemLodingFlgAct,
      setExNowPageAct,
      setExternalDataSendHistoryListAct,
      searchExternalDataSendHistoryAct,
    } = this.props;

    await setExNowPageAct(1);

    const {
      exNowPage,
    } = this.props;
    setSystemLodingFlgAct(true);

    // 検索API呼び出し
    const response = await searchExternalDataSendHistoryAct(
      exProcessNoFrom,
      exProcessNoTo,
      createDateFrom,
      createDateTo,
      linkageProcessNo,
      exNowPage,
    );
    setSystemLodingFlgAct(false);
    setExternalDataSendHistoryListAct(response);
  }

  /**
  * 条件クリア
  */
  onClickClear = () => {
    // 一時保存領域条件クリア
    const {
      setInitExSearchConditionAct,
      setErrorMessageAct,
      setInitExternalDataSendHistoryStateAct,
      setExLimitMessageAct,
    } = this.props;
    setInitExSearchConditionAct();
    setErrorMessageAct('');
    setInitExternalDataSendHistoryStateAct();
    setExLimitMessageAct('');
  }

  render() {
    const {
      exProcessNoFrom,
      exProcessNoTo,
      createDateFrom,
      createDateTo,
      linkageProcessNo,
      setExProcessNoFromAct,
      setExProcessNoToAct,
      setCreateDateFromAct,
      setCreateDateToAct,
      setLinkageProcessNoAct,
      exErrFlg,
      errExProcessNoFromMsg,
      errExProcessNoToMsg,
      errCreateDateFromMsg,
      errCreateDateToMsg,
      errLinkageProcessNoMsg,
    } = this.props;

    registerLocale('ja', ja);

    // エラーフラグが全てTRUEの場合、押下可
    const searchExErrorFlg = Object.keys(exErrFlg).some((key) => exErrFlg[key]);

    return (
      <div className="externalDataHistorySearch">
        <div className="content">
          <Box className="searchItemArea">
            <Grid container spacing={1}>
              <Box display="flex" flexDirection="column" className="searchItemLeft">
                <Typography variant="body2">処理番号</Typography>
              </Box>
              <TextField
                inputProps={{ className: 'padding' }}
                variant="outlined"
                margin="normal"
                className={exErrFlg.errExProcessNoFromFlg ? 'processNoInput' : 'processNoInput'}
                value={exProcessNoFrom || ''}
                onChange={(ev) => setExProcessNoFromAct(ev.target.value)}
                onBlur={this.onBlurExProcessNoFrom}
                error={exErrFlg.errExProcessNoFromFlg}
              />
              {exErrFlg.errExProcessNoFromFlg
                  && (
                  <Box className="balloon-top balloonProcessFrom">
                    <Box className="triangle">
                      <Box />
                    </Box>
                    <div className="bubble">
                      {errExProcessNoFromMsg}
                    </div>
                  </Box>
                  )}
              <Box display="flex" flexDirection="column" className="kigoLayout">
                <Typography variant="body2">～</Typography>
              </Box>
              <TextField
                inputProps={{ className: 'padding' }}
                variant="outlined"
                margin="normal"
                className={exErrFlg.errExProcessNoToFlg ? 'processNoInput' : 'processNoInput'}
                value={exProcessNoTo || ''}
                onChange={(ev) => setExProcessNoToAct(ev.target.value)}
                onBlur={this.onBlurExProcessNoTo}
                error={exErrFlg.errExProcessNoToFlg}
              />
              {errExProcessNoToMsg
                  && (
                  <div className="balloon-top balloonProcessTo">
                    <div className="triangle">
                      <div />
                    </div>
                    <div className="bubble">
                      {errExProcessNoToMsg}
                    </div>
                  </div>
                  )}
              <Box display="flex" flexDirection="column" className="searchItem">
                <Typography variant="body2">作成日</Typography>
              </Box>
              <DatePicker
                className={exErrFlg.errCreateDateFromFlg ? 'dateInput input-error' : 'dateInput'}
                dateFormat="yyyy/MM/dd"
                locale="ja"
                selected={createDateFrom || ''}
                onChange={(ev) => setCreateDateFromAct(ev)}
                onBlur={this.onBlurExCreateDateFrom}
              />
              {exErrFlg.errCreateDateFromFlg
                && (
                <div className="balloon-top balloonDate">
                  <div className="triangle">
                    <div />
                  </div>
                  <div className="bubble">
                    {errCreateDateFromMsg}
                  </div>
                </div>
                )}
              <Box display="flex" flexDirection="column" className="kigoLayout">
                <Typography variant="body2">～</Typography>
              </Box>
              <DatePicker
                className={exErrFlg.errCreateDateToFlg ? 'dateInput input-error' : 'dateInput'}
                dateFormat="yyyy/MM/dd"
                locale="ja"
                selected={createDateTo || ''}
                onChange={(ev) => setCreateDateToAct(ev)}
                onBlur={this.onBlurExCreateDateTo}
              />
              {exErrFlg.errCreateDateToFlg
                && (
                <div className="balloon-top balloonDate">
                  <div className="triangle">
                    <div />
                  </div>
                  <div className="bubble">
                    {errCreateDateToMsg}

                  </div>
                </div>
                )}
              <Box display="flex" flexDirection="column" className="searchItem">
                <Typography variant="body2">連携先：処理番号</Typography>
              </Box>
              <TextField
                inputProps={{ className: 'padding' }}
                variant="outlined"
                margin="normal"
                className={exErrFlg.errLinkageProcessNoFlg ? 'linkageProcessNoInput' : 'linkageProcessNoInput'}
                value={linkageProcessNo || ''}
                onChange={(ev) => setLinkageProcessNoAct(ev.target.value)}
                onBlur={this.onBlurLinkageProcessNo}
                error={exErrFlg.errLinkageProcessNoFlg}
              />
              {exErrFlg.errLinkageProcessNoFlg
                  && (
                  <div className="balloon-top balloonLinkageProcessNo">
                    <div className="triangle">
                      <div />
                    </div>
                    <div className="bubble">
                      {errLinkageProcessNoMsg}
                    </div>
                  </div>
                  )}
            </Grid>
            <Grid container spacing={1} className="grid">
              <Box className="marginAuto" />
              <Box className="buttonArea">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onClickClear}
                  startIcon={<Refresh />}
                >
                  指定条件クリア
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={this.onClickSearchButton}
                  disabled={searchExErrorFlg}
                  className="marginLeftHalf"
                  startIcon={<Search />}
                >
                  この条件で絞り込み
                </Button>
              </Box>
            </Grid>

          </Box>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    exProcessNoFrom: state.externaldata.exProcessNoFrom,
    exProcessNoTo: state.externaldata.exProcessNoTo,
    createDateFrom: state.externaldata.createDateFrom,
    createDateTo: state.externaldata.createDateTo,
    linkageProcessNo: state.externaldata.linkageProcessNo,
    exNowPage: state.externaldata.exNowPage,
    exErrFlg: state.externaldata.exErrFlg,
    errExProcessNoFromMsg: state.externaldata.errExProcessNoFromMsg,
    errExProcessNoToMsg: state.externaldata.errExProcessNoToMsg,
    errCreateDateFromMsg: state.externaldata.errCreateDateFromMsg,
    errCreateDateToMsg: state.externaldata.errCreateDateToMsg,
    errLinkageProcessNoMsg: state.externaldata.errLinkageProcessNoMsg,
    errExternalDataNameMsg: state.externaldata.errExternalDataNameMsg,
  }),
  (dispatch) => ({
    setSystemLodingFlgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setExNowPageAct: (str) => dispatch(setExNowPage(str)),
    setErrorMessageAct: (str) => dispatch(setErrorMessage(str)),
    searchExternalDataSendHistoryAct: (
      exProcessNoFrom, exProcessNoTo, createDateFrom, createDateTo,
      linkageProcessNo, exNowPage,
    ) => dispatch(searchExternalDataSendHistory(
      exProcessNoFrom, exProcessNoTo, createDateFrom, createDateTo,
      linkageProcessNo, exNowPage,
    )),
    setExProcessNoFromAct: (str) => dispatch(setExProcessNoFrom(str)),
    setExProcessNoToAct: (str) => dispatch(setExProcessNoTo(str)),
    setCreateDateFromAct:
      (createDateFrom) => dispatch(setCreateDateFrom(createDateFrom)),
    setCreateDateToAct: (str) => dispatch(setCreateDateTo(str)),
    setLinkageProcessNoAct: (str) => dispatch(setLinkageProcessNo(str)),
    setExternalDataSendHistoryListAct: (str) => dispatch(setExternalDataSendHistoryList(str)),
    setInitExternalDataSendHistoryStateAct: () => dispatch(setInitExternalDataSendHistoryState()),
    setInitExSearchConditionAct: () => dispatch(setInitExSearchCondition()),
    setErrExProcessNoFromMsgAct: (str) => dispatch(setErrExProcessNoFromMsg(str)),
    setErrExProcessNoToMsgAct: (str) => dispatch(setErrExProcessNoToMsg(str)),
    setErrCreateDateFromMsgAct: (str) => dispatch(setErrCreateDateFromMsg(str)),
    setErrCreateDateToMsgAct: (str) => dispatch(setErrCreateDateToMsg(str)),
    setErrLinkageProcessNoMsgAct: (str) => dispatch(setErrLinkageProcessNoMsg(str)),

    setErrExProcessNoFromFlgAct: (str) => dispatch(setErrExProcessNoFromFlg(str)),
    setErrExProcessNoToFlgAct: (str) => dispatch(setErrExProcessNoToFlg(str)),
    setErrCreateDateFromFlgAct: (bool) => dispatch(setErrCreateDateFromFlg(bool)),
    setErrCreateDateToFlgAct: (bool) => dispatch(setErrCreateDateToFlg(bool)),
    setErrLinkageProcessNoFlgAct: (bool) => dispatch(setErrLinkageProcessNoFlg(bool)),
    setExLimitMessageAct: (str) => dispatch(setExLimitMessage(str)),
    startImportPollingAct: () => dispatch(startImportPolling()),
    stopImportPollingAct: () => dispatch(stopImportPolling()),
    getImportStatusAct: () => dispatch(getImportStatus()),
  }),
)(ExternalDataSendHistorySearchComponent);
